
import './index.less';
import { Modal, Table, Tooltip } from "antd";
import classnames from "classnames";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { ReactComponent as PlaceSvg } from '@/commons/icons/table/place.svg';
import { ReactComponent as CheckSvg } from '@/commons/icons/table/check.svg';
import { ReactComponent as CheckedSvg } from '@/commons/icons/table/checked.svg';
import { graphicStore } from "@/commons/store/graphic-store";
import { DEVICE_SUB_CONTROL } from "@/passets/devicebase-engine/enums/device-sub-controls";
import LinkGlobalCableModal from "./link-modal";
import { GlobalCable } from "@/commons/interface/lib-device/global-cable";
import { createProjectGCables, deleteProjectGCable, getProjectCables } from "@/api/maint/project-device/project-cable";
import { RsProjectGlobalCable } from "@/commons/interface/project-device/project-cable";
import axios from "axios";
import { getSpecialPrimitiveLayerUuid } from "@/commons/utils/layer-utils";
import { LayerType } from "@/commons/enums/layer-type";
import { DEVICEBASE_SINGAL } from "@/passets/devicebase-engine/enums/devicebase-singal";
import TnMessage from '@/commons/widget/message';
import SideBarTool from '@/commons/components/side-bar-tool';
import { SideBarBtnType } from '@/commons/enums/side-bar-btn-type';
import TnModal from '@/commons/widget/base-modal';
import { TAB_TYPE } from '@/commons/enums/tab-type';
import { DRAW_MAIN_KEY } from '@/routes/tab-routes';
import { CommonTabbarState } from '@/commons/components/common-tabbar';
import { CommonTabbarContext } from '@/App';


export default function CablePanel() {
    const { projectUuid, modelUuid } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false); // loading
    const [activeRow, setActiveRow] = useState<GlobalCable>(null); // 表格选中行
    const [hoverRow, setHoverRow] = useState<GlobalCable>(null); // 鼠标悬浮行
    const [cables, setCables] = useState<GlobalCable[]>([]); // 线缆列表
    const [showAddModal, setShowAddModal] = useState<boolean>(false); // 打开添加弹窗
    const [addLoading, setAddLoading] = useState<boolean>(false); // 添加弹窗的loading
    const [muitiple, setMuitiple] = useState<boolean>(false); // 是否开启多选
    const [selectedRows, setSelectedRows] = useState<GlobalCable[]>([]); // 多选选中的列

    const [placeRow, setPlaceRow] = useState<GlobalCable>(); // 正在布置的线缆
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext); // tabbar上下文

    // 监听二级控制器结束和按下ESC
    useEffect(() => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onOpeCommandControlEnd.add(onOpeCommandControlEnd);
        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onProcessEscape.add(onOpeCommandControlEnd);

        return () => {
            if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onOpeCommandControlEnd.remove(onOpeCommandControlEnd);
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onProcessEscape.remove(onOpeCommandControlEnd);
        }
    }, [graphicStore?.extraContext?.getCurrentViewEditor()])

    // 初始化
    useEffect(() => {
        if (!projectUuid) return;
        generateData();
    }, [projectUuid])

    // 获取线缆列表
    const generateData = () => {
        setLoading(true);

        getProjectCables(projectUuid).then(res => {
            let data: GlobalCable[] = res.data || [];
            setCables(data);
        }).catch(err => {
            TnMessage.error("查询失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    // 二级控制器执行完成的回调
    const onOpeCommandControlEnd = () => {
        setPlaceRow(null);
    }

    // 监听多选的变化
    useEffect(() => {
        if (!muitiple) {
            setSelectedRows([]);
        }
    }, [muitiple])

    // 点击工具栏添加按钮
    const onAddClick = () => {
        setShowAddModal(true);
    }

    // 点击工具栏删除按钮
    const onDeleteClick = () => {
        if ((muitiple && selectedRows?.length === 0) || (!muitiple && !activeRow)) {
            TnMessage.warning("未选中线缆");
            return;
        }

        TnModal().deleteModal({
            onOk() {
                if (!muitiple) {
                    deleteProjectGCable(projectUuid, activeRow?.id).then(res => {
                        if (res.status === 200) {
                            let idx = cables?.findIndex(item => item.id === activeRow.id);
                            cables.splice(idx, 1);
                            setCables([...cables]);
                            setActiveRow(null);
                            TnMessage.success("删除成功");
                        }
                    }).catch(err => {
                        TnMessage.error("删除失败");
                    }).finally(() => {
                        Modal.destroyAll();
                    })
                } else {
                    let promiseList = [];
                    for (let item of selectedRows) {
                        promiseList.push(() => deleteProjectGCable(projectUuid, item.id));
                    }
                    axios.all(promiseList?.map(fn => fn())).then(res => {
                        let newCables = cables?.filter(item => !selectedRows?.some(r => r.id === item.id));
                        setCables(newCables);
                        setSelectedRows([]);
                        TnMessage.success("删除成功");
                    }).catch(err => {
                        TnMessage.error("删除失败");
                    }).finally(() => {
                        Modal.destroyAll();
                    })
                }
            },
            onCancel() {
                Modal.destroyAll();
            },
            closable: true
        })

    }

    // 添加线缆点击确认
    const onAddFinish = (values) => {

        if (values?.length === 0) {
            setShowAddModal(false);
            return;
        }
        let pars: RsProjectGlobalCable[] = values?.map(item => {
            let par: RsProjectGlobalCable = {
                projectUuid: projectUuid,
                globalCableId: item,
            }
            return par;
        })
        setAddLoading(true);
        createProjectGCables(pars).then(res => {
            if (res.status === 200) {
                let newPCables = res.data || [];
                setCables([...cables, ...newPCables]);
                TnMessage.success("添加成功");
                setShowAddModal(false);
            }
        }).catch(err => {
            TnMessage.error(err?.data || "添加失败");
        }).finally(() => {
            setAddLoading(false);
        })
    }


    // 点击布置按钮
    const onPlaceClick = (row: GlobalCable) => {
        if (!row) return;
        if (!location.pathname.includes('draw/draw-main')) {
            commonTabbarContext.navigate(`${TAB_TYPE.DRAW}/${DRAW_MAIN_KEY}`);
            TnMessage.info("正在切换至绘图区...", { duration: 1 });
            return;
        }
        setPlaceRow(row);
        getSpecialPrimitiveLayerUuid(projectUuid, modelUuid, LayerType.CABLE).then((layerUuid: string) => {
            graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(DEVICE_SUB_CONTROL.ASSEMBLECABLE.name);
            graphicStore.extraContext.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleCable).dispatch(row?.id, layerUuid);
            TnMessage.info("开始布置数据线缆...")
        });

    }


    return (
        <div className="cable-container">
            <SideBarTool onAddBtnClick={onAddClick}
                activeBtnList={[SideBarBtnType.ADD, SideBarBtnType.DELETE, SideBarBtnType.SELECT, SideBarBtnType.UN_SELECT]}
                onDeleteBtnClick={onDeleteClick}
                onSelectBtnClick={() => setMuitiple(true)}
                onUnSelectBtnClick={() => setMuitiple(false)}
            />

            <div className="main-content">
                <div className="panel-title">数据线</div>
                <div className="table-area">
                    <Table
                        rowKey="id"
                        pagination={false}
                        dataSource={cables}
                        className='tn-monix-table'
                        rowClassName={row => classnames({
                            "monix-row-select": activeRow?.id === row.id
                        })}
                        bordered={false}
                        onRow={row => {
                            return {
                                onClick: () => setActiveRow(row),
                                onMouseEnter: () => setHoverRow(row),
                                onMouseLeave: () => setHoverRow(null),
                            }
                        }}
                        sticky
                        loading={loading}
                    >
                        <Table.Column dataIndex="name" title="名称" width='33%' ellipsis
                            render={(value, row: GlobalCable) => {
                                return (
                                    <>
                                        <Tooltip title={value} placement="bottom">
                                            <div className='multi-cell'>
                                                <div className="multi-icon" onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    let idx = selectedRows?.findIndex(item => item.id === row.id);
                                                    if (idx === -1) {
                                                        setSelectedRows([...selectedRows, row]);
                                                    } else {
                                                        selectedRows.splice(idx, 1);
                                                        setSelectedRows([...selectedRows]);
                                                    }
                                                }}>
                                                    {muitiple && !selectedRows?.some(item => item?.id === row?.id) && <CheckSvg />}
                                                    {muitiple && selectedRows?.some(item => item?.id === row?.id) && <CheckedSvg />}
                                                </div>
                                                <div className="multi-text">{value}</div>
                                            </div>
                                        </Tooltip>
                                    </>
                                )
                            }}
                        />
                        <Table.Column dataIndex="marking" title="型号" width='34%' ellipsis align="center"
                            render={(value) => {
                                return (
                                    <Tooltip title={value} placement="bottom">
                                        <div className='cell'>{value}</div>
                                    </Tooltip>
                                )
                            }}
                        />
                        <Table.Column dataIndex="_" title="" width='33%' ellipsis align="right"
                            render={(value, row: GlobalCable) => {
                                if (!!hoverRow && hoverRow?.id === row?.id && !placeRow) {
                                    return (
                                        <div className="place-button" onClick={() => onPlaceClick(row)}>
                                            <div className="place-icon"><PlaceSvg /></div>
                                            <div className="place-text">布置</div>
                                        </div>
                                    )
                                } else {
                                    return (<div className='cell'>{value}</div>)
                                }

                            }}
                        />
                    </Table>
                </div>
            </div>

            {showAddModal && <LinkGlobalCableModal visible={showAddModal} setVisible={setShowAddModal}
                onFinish={onAddFinish} loading={addLoading} filterItems={cables} />}
        </div>
    )
}